import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export type ExportColumn = {
  header: string;
  dataKey: string;
};

export type ExportListingPdfOptions = {
  fileName?: string;
  title: string;
  subtitle?: string;
  generatedOn?: string;
  columns: ExportColumn[];
  rows: Record<string, any>[];
  companyName?: string;
  footerText?: string;
  orientation?: "portrait" | "landscape";
};

export const exportListingPdf = ({
  fileName = "listing.pdf",
  title,
  subtitle = "",
  generatedOn,
  columns,
  rows,
  companyName = "LyraZone Solutions",
  footerText = "SYSTEM GENERATED",
  orientation = "portrait",
}: ExportListingPdfOptions) => {
  const doc = new jsPDF({
    orientation,
    unit: "mm",
    format: "a4",
  });

  const generatedText =
    generatedOn ||
    new Date().toLocaleString("en-MY", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(companyName, 14, 15);

  doc.setFontSize(12);
  doc.text(title, 14, 23);

  if (subtitle) {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(subtitle, 14, 29);
  }

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`Generated On: ${generatedText}`, 14, subtitle ? 35 : 30);

  const head = [columns.map((col) => col.header)];

  const body = rows.map((row) =>
    columns.map((col) => {
      const value = row[col.dataKey];
      return value === null || value === undefined ? "-" : String(value);
    }),
  );

  autoTable(doc, {
    startY: subtitle ? 42 : 36,
    head,
    body,
    styles: {
      fontSize: 9,
      cellPadding: 3,
      valign: "middle",
      textColor: [51, 65, 85],
      lineColor: [226, 232, 240],
      lineWidth: 0.1,
    },
    headStyles: {
      fillColor: [47, 111, 237],
      textColor: 255,
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: [248, 250, 252],
    },
    margin: { left: 14, right: 14 },
    didDrawPage: () => {
      const pageHeight = doc.internal.pageSize.height;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.text(footerText, 14, pageHeight - 10);
    },
  });

  doc.save(fileName);
};